module.exports = "input {\r\n    font-size: XX-Large;\r\n}\r\n\r\nlabel, select {\r\n    font-size: X-Large;\r\n}\r\n\r\n\r\n.toggle-switch .ts-helper {\r\n    width: 52px; \r\n    height: 26px; \r\n}\r\n\r\n.toggle-switch .ts-helper:before {\r\n    width: 36px;\r\n    height: 36px;\r\n}\r\n\r\n.btn-form-pesquisa {\r\n    min-width: 200px;\r\n    min-height: 50px; \r\n    z-index: 999;    \r\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/pesquisa/pesquisa-touch/pesquisa-touch.component.css
 ** module id = 473
 ** module chunks = 0
 **/